export const OPEN_SUBMENU = 'OPEN_SUBMENU';
export const STORE_ACCNO = 'STORE_ACCNO';